import { render, staticRenderFns } from "./SelectZapForRepair.vue?vue&type=template&id=584a2a24&scoped=true&"
import script from "./SelectZapForRepair.vue?vue&type=script&lang=js&"
export * from "./SelectZapForRepair.vue?vue&type=script&lang=js&"
import style0 from "./SelectZapForRepair.vue?vue&type=style&index=0&id=584a2a24&lang=scss&scoped=true&"
import style1 from "./SelectZapForRepair.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a2a24",
  null
  
)

export default component.exports